import type { CatalogPreset } from "./api";

export const STUDIO_FRAMING_ORDER = [
  "full-body",
  "three-quarter",
  "upper-body",
  "lower-body",
  "profile",
] as const;

export const STUDIO_FRAMING_LABELS: Record<string, string> = {
  "full-body": "전신",
  "three-quarter": "7부 · 무릎",
  "upper-body": "상반신 · 허리",
  "lower-body": "하반신 · 허리 아래",
  profile: "프로필 · 가슴",
};

const STUDIO_ANGLE_ORDER = [
  "front",
  "three-quarter",
  "three-quarter-left",
  "three-quarter-right",
  "side",
  "side-left",
  "side-right",
  "back",
] as const;

function rank(value: string, order: readonly string[]) {
  const index = order.indexOf(value);
  return index === -1 ? order.length : index;
}

export function sortPresetsForStudio<T extends CatalogPreset>(items: T[]) {
  return [...items].sort((left, right) => {
    const framingDifference =
      rank(left.framing, STUDIO_FRAMING_ORDER) -
      rank(right.framing, STUDIO_FRAMING_ORDER);
    if (framingDifference !== 0) return framingDifference;

    const angleDifference =
      rank(left.viewAngle, STUDIO_ANGLE_ORDER) -
      rank(right.viewAngle, STUDIO_ANGLE_ORDER);
    if (angleDifference !== 0) return angleDifference;

    return left.order - right.order || left.code.localeCompare(right.code);
  });
}

export function groupPresetsByFraming<T extends CatalogPreset>(items: T[]) {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const group = groups.get(item.framing) ?? [];
    group.push(item);
    groups.set(item.framing, group);
  }
  return [...groups.entries()]
    .sort(
      ([left], [right]) =>
        rank(left, STUDIO_FRAMING_ORDER) - rank(right, STUDIO_FRAMING_ORDER),
    )
    .map(([framing, presets]) => ({
      framing,
      label: STUDIO_FRAMING_LABELS[framing] ?? framing,
      presets,
    }));
}
